// @flow

import { UPDATE_PASSWORD, UPDATE_PASSWORD_ERROR, UPDATE_PASSWORD_SUCCESS } from './constants';
import type { Action, ActionData } from '../types';

export const updatePassword = (data: ActionData): Action => ({
  type: UPDATE_PASSWORD,
  data
});

export const updatePasswordError = (_id: string, error: Error): Action => ({
  type: UPDATE_PASSWORD_ERROR,
  error
});

export const updatePasswordSuccess = (): Action => ({
  type: UPDATE_PASSWORD_SUCCESS
});
